import React, { useEffect, useState } from "react";
import { CardNumberElement, CardExpiryElement, CardCvcElement, useStripe, useElements } from "@stripe/react-stripe-js";
import CircularProgress from "@mui/material/CircularProgress";
import { Snackbar, Alert } from "@mui/material";
import config from "../../config";
import PaymentMethods from "./PaymentMethods";
import PriceDetails from "./PriceDetails";
import { postApi } from "../AppApis";
import { toast } from "react-toastify";
import VerifyAccountPopup from "../../components/ListNowComponents/VerifyAccountPopup";
import { useProfile } from "../../contexts/ProfileContext";
import Balls from "../Templates/Loading";
import { Spinner } from "@nextui-org/react";
import { showErrorToast } from "../utils";
const StripeComponent = ({
    onPaymentSuccess,
    setActiveStep,
    onBack,
    onSetLoading,
    setSuccess,
    showError,
    fullName,
    total_price,
    selected_items,
    package_type,
}) => {
    const stripe = useStripe();
    const { profileData } = useProfile();

    const elements = useElements();
    const [loading, setLoading] = useState(false); // Loading state
    const [promocode, setPromocode] = useState("");
    const [holderName, setHolderName] = useState("");
    const [zipCode, setZipCode] = useState("");
    const [isShowVerificaionPopup, setIsShowVerificaionPopup] = useState(false);
    const [errors, setErrors] = useState({
        cardNumber: "",
        cardExpiry: "",
        cardCvc: "",
        zipCode: "",
    });

    useEffect(() => {
        const getLocalData = JSON.parse(localStorage.getItem("newLocalData"));
        if (getLocalData) {
            setHolderName(getLocalData.holderName);
            setZipCode(getLocalData.zipCode);
            setPromocode(getLocalData.promoCode);
        }
    }, []);
    const validateZipCode = (zip) => {
        const zipRegex = /^\d{5}(-\d{4})?$/; // US ZIP format: 12345 or 12345-6789
        return zipRegex.test(zip);
    };
    const handleChange = (event, field) => {
        if (event.error) {
            setErrors((prev) => ({ ...prev, [field]: event.error.message }));
        } else {
            setErrors((prev) => ({ ...prev, [field]: event.complete ? "" : "This field is required" }));
        }
    };

    const onClickPay = async (payment) => {
        setLoading(true);
        if (promocode) {
            const isPromoCodeValid = await postApi("/property-services/check_promo", { code: promocode });
            if (isPromoCodeValid.error) {
                showErrorToast("Promo code is not valid");
                showError("Promo code is not valid");
                setLoading(false);
                return;
            }
        }

        if (!stripe || !elements) {
            console.log("error2");
            return;
        }

        const cardNumber = elements.getElement(CardNumberElement);

        try {
            const { paymentMethod, error } = await stripe.createPaymentMethod({
                type: "card",
                card: cardNumber,
            });

            const { token, errorToken } = await stripe.createToken(cardNumber);

            if (error || errorToken) {
                showError("Error creating payment method: " + (error || errorToken).message);
                setLoading(false);
                onSetLoading(false);
                return;
            }

            await sendThePaymentToServer(paymentMethod.id, token.id, payment);
        } catch (error) {
            showError("Payment error: " + error.message);
            setLoading(false);
            onSetLoading(false);
            showError("Payment error:" + error.message);
        }
    };

    const sendThePaymentToServer = async (paymentMethodId, tokenId, payment) => {
        try {
            // Prepare the payload and log all its contents
            const payload = {
                property_id: localStorage.getItem("transaction_id"),
                token: tokenId,
                code: promocode,
                payment_amount: parseFloat(total_price?.toFixed(2)),
                package_type,
                selected_items,
                project_type: "onmls",
                cardholdername: holderName,
                zipcode: zipCode,
            };
            const response = await postApi("/properties/purchase_package", payload);
            // Check for success response
            if (response.response) {
                localStorage.removeItem("sellAddress");
                localStorage.removeItem("sellImages");
                localStorage.removeItem("newLocalData");
                localStorage.removeItem("propertiesData");
                localStorage.removeItem("transaction_id");
                localStorage.removeItem("yardCount");
                localStorage.removeItem("lockBoxesCount");
                localStorage.removeItem("advertising_credits");
                if (profileData?.is_id_verified !== true) {
                    setIsShowVerificaionPopup(true);
                } else {
                    onPaymentSuccess(200);
                    setSuccess(true);
                }
            } else {
                toast.error(response.error.error || "Payment not successful. Please try again.");
                // Handle specific errors
                if (response.error === "Failed to send email.") {
                    showError("Payment was processed, but the confirmation email could not be sent. Please check your email settings.");
                } else {
                    showError(response.error.error || "Payment not successful. Please try again.");
                }
            }
        } catch (error) {
            console.error("Server error during payment:", error.error);
            showError("Server error during payment: " + error.error.error);
        } finally {
            setLoading(false);
            onSetLoading(false);
        }
    };

    const itemPrices = {
        yard_sign: 70,
        lockbox: 70,
        advertising_credits: 70,
    };
    const allItems = [
        { name: "yard_sign", displayName: "Yard Sign" },
        { name: "lockbox", displayName: "Lockbox" },
        { name: "advertising_credits", displayName: "Advertising Credits" },
    ];
    const listingPrice = package_type === "basic" ? "$0" : package_type === "premium" ? "$29" : "$59";
    const selectedItemsMap = selected_items.reduce((acc, item) => {
        acc[item.name] = item.count;
        return acc;
    }, {});
    const pricingSummaryArray = [
        {
            title: "Listing charges",
            value: listingPrice,
        },
        ...allItems.map((item) => {
            const count = selectedItemsMap[item.name] || 0;
            const total = count * itemPrices[item.name];
            return {
                title: `${item.displayName} (${count})`,
                value: count > 0 ? `$${total.toFixed(2)}` : "0",
                count: count,
                pricePerItem: itemPrices[item.name],
            };
        }),
    ];
    const validateFields = () => {
        let isValid = true;
        const newErrors = { ...errors };

        // Validate holder name
        if (!holderName.trim()) {
            newErrors.holderName = "Cardholder name is required";
            isValid = false;
            showErrorToast("Please enter cardholder name");
        } else {
            newErrors.holderName = "";
        }

        // Validate zip code
        if (!zipCode.trim()) {
            newErrors.zipCode = "ZIP code is required";
            isValid = false;
            showErrorToast("Please enter ZIP code");
        } else if (!validateZipCode(zipCode)) {
            newErrors.zipCode = "Invalid ZIP code format";
            isValid = false;
            showErrorToast("Please enter a valid 5-digit ZIP code");
        } else {
            newErrors.zipCode = "";
        }
        if (!stripe) {
            showErrorToast("Please enter a valid card details");
            isValid = false;
        }

        setErrors(newErrors);
        return isValid;
    };

    const handleNameChange = (e) => {
        const value = e.target.value.replace(/[^A-Za-z\s]/g, ""); // Allow only letters and spaces
        // allow only 50 characters
        if (value.length > 50) {
            return;
        }
        const newLocalData = {
            holderName: value,
            zipCode: zipCode,
            promoCode: promocode,
        };
        localStorage.setItem("newLocalData", JSON.stringify(newLocalData));
        setHolderName(value);
    };

    const handleChangeZipCode = (e) => {
        const value = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters
        setZipCode(value);
        const newLocalData = {
            holderName: holderName,
            zipCode: value,
            promoCode: promocode,
        };
        localStorage.setItem("newLocalData", JSON.stringify(newLocalData));
        if (!validateZipCode(value)) {
            setErrors((prev) => ({ ...prev, zipCode: "Invalid ZIP code format" }));
        } else {
            setErrors((prev) => ({ ...prev, zipCode: "" }));
        }
    };
    return (
        <>
            <form className="tw-w-full tw-max-w-4xl tw-mx-auto tw-py-8 tw-px-4">
                <div className="tw-text-left tw-mb-6 tw-flex tw-justify-between tw-flex-col lg:tw-flex-row tw-gap-6 lg:tw-gap-8">
                    <PriceDetails pricingSummaryArray={pricingSummaryArray} total_price={total_price?.toFixed(2) ? total_price?.toFixed(2) : 0} />
                    <PaymentMethods />
                </div>
                <div className="tw-text-left tw-mb-6 tw-flex tw-justify-between">
                    <span className="tw-font-sans tw-font-bold tw-text-xl tw-leading-[46px] tw-text-black">Card Details</span>
                </div>
                <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-4">
                    <div className="tw-mb-4 md:tw-col-span-2">
                        <label className="tw-font-sans tw-font-bold tw-text-sm tw-text-black tw-block tw-mb-2">Cardholder's Name</label>
                        <input
                            type="text"
                            placeholder="Enter Name"
                            required={true}
                            value={holderName}
                            onChange={handleNameChange}
                            className="tw-w-full tw-py-3 tw-px-4 tw-bg-white tw-border tw-outline-none focus:tw-border-2 tw-rounded-md focus:tw-border-secondary tw-text-base"
                        />
                    </div>
                    <div className="tw-mb-4">
                        <label className="tw-font-sans tw-font-bold tw-text-sm tw-text-black tw-block tw-mb-2">Card Number</label>
                        <div className="tw-w-full tw-bg-white tw-py-3 tw-px-4 tw-border tw-rounded-md">
                            <CardNumberElement onChange={(event) => handleChange(event, "cardNumber")} />
                        </div>
                        {errors.cardNumber && <p className="tw-text-red-500 tw-text-sm">{errors.cardNumber}</p>}
                    </div>
                    <div className="tw-mb-4">
                        <label className="tw-font-sans tw-font-bold tw-text-sm tw-text-black tw-block tw-mb-2">Expire</label>
                        <div className="tw-w-full tw-py-3 tw-px-4 tw-bg-white tw-border tw-rounded-md">
                            <CardExpiryElement onChange={(event) => handleChange(event, "cardExpiry")} />
                        </div>
                        {errors.cardExpiry && <p className="tw-text-red-500 tw-text-sm">{errors.cardExpiry}</p>}
                    </div>
                    <div className="tw-mb-4">
                        <label className="tw-font-sans tw-font-bold tw-text-sm tw-text-black tw-block tw-mb-2">CVC</label>
                        <div className="tw-w-full tw-py-3 tw-px-4 tw-bg-white tw-border tw-rounded-md">
                            <CardCvcElement onChange={(event) => handleChange(event, "cardCvc")} />
                        </div>
                        {errors.cardCvc && <p className="tw-text-red-500 tw-text-sm">{errors.cardCvc}</p>}
                    </div>
                    <div className="tw-mb-4">
                        <label className="tw-font-sans tw-font-bold tw-text-sm tw-text-black tw-block tw-mb-2">Zip Code</label>
                        <input
                            type="text"
                            placeholder="Enter Zip Code"
                            maxLength={5}
                            value={zipCode}
                            onChange={handleChangeZipCode}
                            className="tw-w-full tw-py-3 tw-px-4 tw-bg-white tw-border tw-outline-none focus:tw-border-2 tw-rounded-md focus:tw-border-secondary"
                        />
                        {errors.zipCode && <p className="tw-text-red-500 tw-text-sm">{errors.zipCode}</p>}
                    </div>
                    <div className="tw-mb-4">
                        <label className="tw-font-sans tw-font-bold tw-text-sm tw-text-black tw-block tw-mb-2">Promo Code</label>
                        <input
                            type="text"
                            placeholder="Enter Promo code"
                            value={promocode}
                            onChange={(e) => {
                                if (e.target.value.length > 12) {
                                    return;
                                }
                                setPromocode(e.target.value);
                                const newLocalData = {
                                    holderName: holderName,
                                    zipCode: zipCode,
                                    promoCode: e.target.value,
                                };
                                localStorage.setItem("newLocalData", JSON.stringify(newLocalData));
                            }}
                            className="tw-w-full tw-py-3 tw-px-4 tw-bg-white tw-border tw-outline-none focus:tw-border-2 tw-rounded-md focus:tw-border-secondary"
                        />
                    </div>
                </div>
                <div className="tw-text-sm tw-text-gray-500 tw-mt-6">
                    Our payment process employs advanced encryption to protect your financial information and ensure secure, reliable transactions.
                </div>{" "}
                <div className="tw-flex tw-flex-col sm:tw-flex-row tw-items-center tw-gap-4 tw-mt-6 tw-justify-center">
                    <button
                        className="tw-w-full sm:tw-w-auto tw-min-w-[140px] tw-p-3 tw-px-6 tw-text-primary tw-border-primary tw-border tw-rounded-lg disabled:tw-cursor-not-allowed tw-bg-[#fff] disabled:tw-bg-[#C2BABE] tw-font-medium"
                        type="button"
                        onClick={onBack}
                    >
                        Back
                    </button>
                    <button
                        onClick={(e) => {
                            e.preventDefault();
                            if (loading) return;
                            if (!validateFields()) {
                                return;
                            }
                            onClickPay("497");
                        }}
                        disabled={loading}
                        className="tw-w-full sm:tw-w-auto tw-min-w-[180px] tw-px-6 tw-py-3 tw-bg-primary hover:tw-bg-primary_hover tw-text-white tw-rounded-lg disabled:tw-cursor-not-allowed tw-font-medium"
                    >
                        {loading ? <CircularProgress size={20} color="inherit" /> : "Confirm And Pay"}
                    </button>
                </div>
            </form>
            {isShowVerificaionPopup && <VerifyAccountPopup />}
        </>
    );
};

export default StripeComponent;
